import { ApiError } from "./apiClient";

// Deterministic client errors: a retry returns the same answer.
// 401 also has its own token-refresh path in apiClient.
const NON_RETRYABLE_STATUSES = new Set([401, 403, 404]);

export function shouldRetryQuery(
  failureCount: number,
  error: unknown,
): boolean {
  if (error instanceof ApiError && NON_RETRYABLE_STATUSES.has(error.status)) {
    return false;
  }
  return failureCount < 2;
}
